import React, { useEffect, useMemo, useRef, useState } from 'react';
import * as inquiry from './inquirySubmission';

const CountryCodeSelector = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const rootRef = useRef(null);
  const searchRef = useRef(null);
  const selectedCountry = inquiry.getCountryPhoneRule(value);

  const filteredCountries = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return inquiry.COUNTRY_PHONE_OPTIONS;

    return inquiry.COUNTRY_PHONE_OPTIONS.filter((country) =>
      [country.name, country.value, country.dialCode]
        .some((item) => item.toLowerCase().includes(query))
    );
  }, [search]);

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearch('');
      }
    };

    document.addEventListener('mousedown', closeOnOutsideClick);
    return () => document.removeEventListener('mousedown', closeOnOutsideClick);
  }, []);

  useEffect(() => {
    if (isOpen) searchRef.current?.focus();
  }, [isOpen]);

  const selectCountry = (countryCode) => {
    onChange(countryCode);
    setIsOpen(false);
    setSearch('');
  };

  return (
    <div className="contact-country-selector" ref={rootRef}>
      <button
        type="button"
        className="contact-country-selector__trigger"
        aria-label={`Country code ${selectedCountry.dialCode}. Select another country`}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((open) => !open)}
      >
        <span>{selectedCountry.dialCode}</span>
        <span className="contact-country-selector__arrow" aria-hidden="true">▾</span>
      </button>

      {isOpen && (
        <div className="contact-country-selector__menu">
          <input
            ref={searchRef}
            type="search"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Escape') {
                setIsOpen(false);
                setSearch('');
              }
            }}
            placeholder="Search country or code"
            aria-label="Search country or calling code"
          />
          <div className="contact-country-selector__options" role="listbox">
            {filteredCountries.length ? filteredCountries.map((country) => (
              <button
                type="button"
                role="option"
                aria-selected={country.value === value}
                className={`contact-country-selector__option${country.value === value ? ' is-selected' : ''}`}
                key={country.value}
                onClick={() => selectCountry(country.value)}
              >
                <span>{country.name}</span>
                <strong>{country.dialCode}</strong>
              </button>
            )) : (
              <div className="contact-country-selector__empty">No country found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CountryCodeSelector;
